import axios from '@/utils/axios'


// 基础登录信息 ------------------
// 登录
export function login(data) {
  return axios({
    url: '/api/admin/auth/login',
    method: 'POST',
    data: data
  })
}

export function register(data) {
  return axios({
    url: '/api/admin/auth/register',
    method: 'POST',
    data: data
  })
}


export function getMyInfo(data) {
  return axios({
    url: '/api/admin/auth/me',
    method: 'GET',
    params: data
  })
}

export function getOss(data) {
  return axios({
    url: '/api/admin/oss/policy',
    method: 'GET',
    params: data
  })
}

export function getTasks(data) {
  return axios({
    url: '/api/admin/tasks/list',
    method: 'GET',
    params: data
  })
}


export function addTasks(data) {
  return axios({
    url: '/api/admin/tasks',
    method: 'POST',
    data: data
  })
}


export function getGoods(data) {
  return axios({
    url: '/api/admin/goods/list',
    method: 'GET',
    params: data
  })
}


export function addGoods(data) {
  return axios({
    url: '/api/admin/goods',
    method: 'POST',
    data: data
  })
}


export function offlineGoods(data) {
  return axios({
    url: '/api/admin/goods/' + data.id + "/offline",
    method: 'POST',
    data: data
  })
}


export function onlineGoods(data) {
  return axios({
    url: '/api/admin/goods/' + data.id + "/online",
    method: 'POST',
    data: data
  })
}


export function getOrders(data) {
  return axios({
    url: '/api/admin/orders/list',
    method: 'GET',
    params: data
  })
}

export function delivery(data) {
  return axios({
    url: '/api/admin/orders/delivery',
    method: 'POST',
    data: data
  })
}


export function getConfig(data) {
  return axios({
    url: '/api/admin/reward-config',
    method: 'GET',
    params: data
  })
}

export function postConfig(data) {
  return axios({
    url: '/api/admin/reward-config',
    method: 'POST',
    data: data
  })
}

export function deleteConfig(data) {
  return axios({
    url: '/api/admin/reward-config/' + data.id,
    method: 'DELETE'
  })
}


export function getCheckinAll(data) {
  return axios({
    url: '/api/admin/checkin/all',
    method: 'GET',
    params: data
  })
}

export function postAudit(data) {
  return axios({
    url: '/api/admin/checkin/audit',
    method: 'POST',
    data: data
  })
}

export function addDraw(data) {
  return axios({
    url: '/api/admin/tasks/' + data.taskId + '/draw',
    method: 'POST',
    data: {
      winnerUserId: data.winnerUserId,
      goodsId: data.goodsId
    }
  })
}



export default {
  login,
  register,
  getMyInfo,
  getOss,
  getTasks,
  addTasks,
  getGoods,
  addGoods,
  offlineGoods,
  onlineGoods,
  getOrders,
  delivery,
  getConfig,
  postConfig,
  deleteConfig,
  getCheckinAll,
  postAudit,
  addDraw
}



// WEBPACK FOOTER //
// ./src/api/apiList.js